import {
	AppThemeAtom,
	atomStore,
	isInWaitingRoomAtom,
	localeAtom,
	pubSubService,
	ResponseStatus50xError,
	waitingRoomSessionIdAtom
} from '@capsicum/common';
import { type AxiosResponse } from 'axios';

import { env } from '../../../../util/env';

const WR_URL = env.NEXT_PUBLIC_WR_URL;

export const waitingRoomDetectInterceptor = (response: AxiosResponse) => {
	const WRSessionId =
		response.headers?.['x-socios-wr-id'] || (response?.data?.['socios_wr_id'] as string | undefined);

	if (WRSessionId) atomStore.set(waitingRoomSessionIdAtom, WRSessionId);

	if (response.status !== 288) return response;

	atomStore.set(isInWaitingRoomAtom, true);

	if (typeof window !== 'undefined' && WR_URL) {
		const url = new URL(WR_URL);
		const theme = atomStore.get(AppThemeAtom);
		const locale = atomStore.get(localeAtom);

		url.searchParams.set('locale', locale);
		url.searchParams.set('theme', theme);
		window.location.href = url.toString();
	}

	pubSubService.publish('globalError', new ResponseStatus50xError(new Error('Redirecting to Waiting Room')));

	return response;
};
